/**
 * 精选车辆推荐
 */
import React from 'react';

import { Row, Col, Icon, Tooltip, DatePicker, Input, Select, TreeSelect } from 'antd';

import PageLayout from '../../ui/PageLayout';

import http from '../../../axios/http';

//车辆详情信息和审核
import AuctionCarInfoDetail from './AuctionCarInfoDetail';
//加载中遮罩
import Loading from '../../ui/Loading';

import messager from '../../ui/messager';
import PdfViewer from '../../ui/PdfViewer';
//维保报告查看
import MaintenanceReport from '../../mall/maintenance/MaintenanceReport';

import { treeDataConversion, buildTree } from '../../ui/treeData';

const { Option } = Select;

class AuctionCarInfoIndex extends React.Component {

    columns = [{
        title: '创建人',
        dataIndex: 'nickname',
        width: '7%',
    }, {
        title: '车辆名称',
        dataIndex: 'vehicleName',
        width: '20%',
    }, {
        title: '车辆来源',
        dataIndex: 'clientSource',
        width: '10%',
    }, {
        title: '车架号',
        dataIndex: 'vin',
        width: '15%',
    }, {
        title: '提交时间',
        dataIndex: 'insertTime',
        width: '10%',
    }, {
        title: '起始价',
        dataIndex: 'auctionLots.startPrice',
        width: '6%',
    }, {
        title: '最终价格',
        dataIndex: 'auctionLots.finalPrice',
        width: '8%',
    }, {
        title: '获胜会员',
        dataIndex: 'auctionLots.memberName',
        width: '10%',
    }, {
        title: '关注人数',
        dataIndex: 'auctionLots.followNum',
        width: '8%',
    }, {
        title: '结果',
        dataIndex: 'auctionLots.status',
        width: '8%',
        format: { 0: '无人出价', 1: '成交', 2: '低于保留价', 3: '竞价成功，但没有成交', null: "即将竞价" }
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '15%',
        render: (text, record, index) => (
            <div>
                <Tooltip title="详情">
                    <Icon type="eye" theme="filled" className="table-operate-icon" onClick={this.detail.bind(this, record)} />
                </Tooltip>
                {
                    record.signTaskStatus === 2 ?
                        <Tooltip title="查看已签署完成的委托竞卖合同">
                            <Icon type="file-pdf" className="table-operate-icon" onClick={this.openPdf.bind(this, record, "signDoc")} />
                        </Tooltip> : ''
                }
                <Tooltip title="查看竞价车辆信息">
                    <Icon type="file-pdf" className="table-operate-icon" onClick={this.openPdf.bind(this, record, "vehicleInfo")} />
                </Tooltip>
                <Tooltip title="下载竞卖合同">
                    <Icon type="download" className="table-operate-icon" onClick={this.download.bind(this, record)} />
                </Tooltip>
                {record.report != null && record.report.status !== 0 ?
                    <Tooltip title="车辆维保信息详情">
                        <Icon type="file-done" className="table-operate-icon" onClick={this.maintenanceReportDetail.bind(this, record)} />
                    </Tooltip> : ""
                }
            </div>
        )
    }];

    state = {
        visible: false,
        editData: { "auctionLots": {} },
        loadData: '',
        queryData: {},
        loadingVisible: false,
        pdfVisible: false,

        reportVisible: false,
        reportData: {},
    };

    componentDidMount() {
        //获取客户来源数据
        http.post({
            url: '/dict/findDict',
            data: { category: "VEHICLE_CLIENT_SOURCE" },
            success: (res) => {
                res = res == null ? [] : res;
                //把客户来源字典重构为符合treeSelect格式要求的树形结构
                res = buildTree(res);
                treeDataConversion(res, false);
                //把res的code设置为name[code]，为了能用treeSelect的搜索
                this.handleTreeCode(res)
                this.setState({ clientSourceData: res});
            }
        });
    }

    handleTreeCode = (treeData) => {
        var stack = [];
        stack = stack.concat(treeData);
        while (stack != null && stack.length > 0) {
            let node = stack[0];
            stack.splice(0, 1);
            if (node.children != null) {
                stack = stack.concat(node.children);
            }
            //value设置为name[value]
            node.value = node.title + "[" + node.value + "]";
        }
    }

    hiddenModal = () => {
        this.setState({ visible: false, editData: { "auctionLots": {} } });
    };

    detail = (info, e) => {
        this.setState({ loadingVisible: true });
        http.get({
            url: '/auction/carInfo/detail',
            data: { id: info.id },
            success: (res) => {
                if (res !== null) {
                    this.setState({ editData: res, visible: true, loadingVisible: false });
                }
                else {
                    messager.notify("获取车辆信息失败！")
                    this.setState({ visible: true, loadingVisible: false });
                }
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    /**
     *  打开pdf文档，
     *  type 文档类型，vehicleInfo: 竞价车辆信息，signDoc:已签署完成的文档
     */ 
    openPdf = (info, type) => {
        this.setState({ loadingVisible: true });
        let url = "/auction/web/audit/download/vehicleinfo/pdf";
        if(type === "signDoc"){
            url = "/auction/web/audit/download/finishedContract/pdf";
        }
        this.refs["pdfViewer"].loadFile({
            url: url,
            data: { id: info.id },
            success: (res) => {
                this.setState({ loadingVisible: false, pdfVisible: true });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    download = (info) => {
        this.setState({ loadingVisible: true });
        let url = "/auction/web/audit/download/contract";
        let fileName = "委托竞卖合同.docx";
        http.download({
            url: url,
            data: { "id": info.id },
            fileName: fileName,
            success: (res) => {
                this.setState({ loadingVisible: false });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }


    // 查看维保报告详细信息
    maintenanceReportDetail = (data, e) => {
        let info = data.report;
        if (info == null) return;
        this.setState({ loadingVisible: true });
        if (info.status === 2) {
            http.get({
                url: '/maintenance/findReport',
                data: { id: info.id },
                success: (res) => {
                    this.setState({ reportData: res, reportVisible: true, loadingVisible: false });
                }, error: (res) => {
                    this.setState({ loadingVisible: false });
                }
            });
        } else {
            this.setState({ reportData: info, reportVisible: true, loadingVisible: false });
        }
    }

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    onSelect = (res) => {
        let queryData = this.state.queryData;
        queryData.status = res;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    onSelect = (field, res) => {
        let queryData = this.state.queryData;
        queryData[field] = res;
        if (field === "clientSource" && res) {
            let start = res.indexOf("[");
            queryData[field] = res.substring(start + 1, res.length -1);
        }
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    inputSearch = (value) => {
        let queryData = this.state.queryData;
        queryData.keywords = value
        this.state.loadData(queryData);
        this.setState({ queryData: queryData });
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={24}>
                                <Input.Search
                                    placeholder="车辆关键字或车架号"
                                    onSearch={this.inputSearch}
                                    enterButton
                                    style={{ width: '250px' }} />
                                <DatePicker.RangePicker onChange={this.rangePickerChange} style={{ margin: '0 10px' }} />
                                <Select placeholder="竞价状态" onChange={this.onSelect.bind(this, "status")} allowClear style={{ width: '150px', margin: '0 10px' }}>
                                    <Option value="WILL_AUCTION">即将竞价</Option>
                                    <Option value="DEAL">竞价成功</Option>
                                    <Option value="AUCTION_FAIL">竞价失败</Option>
                                </Select>
                                <TreeSelect placeholder="客户来源" multiple={false}  onChange={this.onSelect.bind(this, "clientSource")} allowClear 
                                treeData={this.state.clientSourceData} treeDefaultExpandAll={false} showSearch={true} style={{ width: '150px', margin: '0 10px' }}/>
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/auction/carInfo/page"
                    requestType="get"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <AuctionCarInfoDetail
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                />
                <MaintenanceReport
                    visible={this.state.reportVisible}
                    onCancel={() => this.setState({ reportVisible: false })}
                    editData={this.state.reportData}
                />
                <PdfViewer
                    visible={this.state.pdfVisible}
                    onCancel={() => { this.setState({ pdfVisible: false }) }}
                    ref="pdfViewer"
                />
                <Loading
                    visible={this.state.loadingVisible}
                    message="数据加载中..."
                />
            </div>
        )
    }
}

export default AuctionCarInfoIndex;